import { AnyOperationLogEntityVersion, OperationDataStateMap } from '@uploadcam/common';
import { CollectionReference, doc, Timestamp, updateDoc } from 'firebase/firestore';
import { OperationLog } from '../models/operation-log';

export class SetOperationLogStateInteractor {
  constructor(private readonly collection: CollectionReference<AnyOperationLogEntityVersion>) {}

  public async execute<T extends keyof OperationDataStateMap>(
    log: OperationLog<T>,
    state: OperationDataStateMap[T],
  ): Promise<void> {
    await updateDoc(doc(this.collection, log.id), {
      'operation.state': state,
      updatedAt: Timestamp.now(),
    });
  }
}
